import React, { useState, useContext } from 'react'
import { CircularProgress, Grid, Radio, RadioGroup } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import './PolicyCOIDetails.scss';
import { PolicyCOIExtensionContextStore } from '../../../../context/PolicyCOIExtensionContext'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService'
import { awaitWithLoading } from '../../../../services/utils'
import policymanagementCoiApi from '../../../../api/policymanagement.coi.api'
import { BrowserView, isMobile } from 'react-device-detect';
import NewFillButton from '../../../Core/NewFillButton';
import './ListPolicyCOIView.scss';
const ALL_INSUREDS = 'All Insureds'

export const ListPolicyCOIView = ({insurance}) => {
    const [selectedCOI, setSelectedCOI] = useState('');
    const policyCoiContext = useContext(PolicyCOIExtensionContextStore)

    const loadCois = async () => {
        if (insurance.insuranceId) {
            await policyCoiContext.loadPolicyCOIs(insurance.insuranceId)
        }
    }

    React.useEffect(() => {
        loadCois()
        let id = EventEmitterService.subscribe(EventKey.ADDITIONAL_INSURED_FINISH)

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.ADDITIONAL_INSURED_FINISH, id)
        }
    }, [])

    const handleRadioChange = (event) => {
        setSelectedCOI(event.target.value);
    };

    const handleViewSelectedCOI = async () => {
        if (selectedCOI) {
            if(selectedCOI === ALL_INSUREDS) {
                const {data} = await awaitWithLoading(policymanagementCoiApi.getMeargedPolicyCOIs(insurance.insuranceId)) 
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(data)
                link.download = 'all_additional_insureds.pdf'
                link.click()
                link.remove()
            } else {
                const coi = policyCoiContext.cois.find(coi => coi.additionalInsuredName === selectedCOI)
                const url = await policymanagementCoiApi.getSpecificCOIUrl(insurance.insuranceId, coi.additionalInsuredId)
                window.open(url.data, '_blank');
            }
        }
    };

    return (
        <>
           <BrowserView>
                <div className="text-body blue textcenter bold margin-bottom-basic">Select and download additional insured certification</div>
            </BrowserView>
            <Grid container className="margin-top-medium" spacing={3}>
                {policyCoiContext.cois.length === 0 ?
                    <Grid item xs={12}>
                        <FlexView hAlignContent='center' className="margin-top-large margin-bottom-large" vAlignContent='center'>
                            <CircularProgress />
                        </FlexView>
                    </Grid>
                :
                <>

                    <RadioGroup 
                        value={selectedCOI} 
                        onChange={handleRadioChange}
                        className="coi-radio-group">
                        <FlexView 
                                vAlignContent="center" 
                                className="coi-radio-item margin-bottom-small"
                            >
                                <Radio 
                                    value={ALL_INSUREDS}
                                    className="coi-radio blue"
                        color="primary"                    
                                />
                                <AccountCircleIcon className="margin-horizontal-small text-secondary" />
                                <FlexView column>
                                    <span className="text-body">
                                        {ALL_INSUREDS}
                                    </span>
                                </FlexView>
                            </FlexView>
                        {policyCoiContext.cois.filter(coi => coi.additionalInsuredName != undefined).map((coi, index) => (
                            <FlexView 
                                key={index}
                                vAlignContent="center" 
                                className="coi-radio-item margin-bottom-small"
                            >
                                <Radio 
                                    value={coi.additionalInsuredName}
                                    className="coi-radio"
                                    color="primary" 
                                />
                                <AccountCircleIcon className="margin-horizontal-small text-secondary" />
                                <FlexView column>
                                    <span className="text-body">
                                        {coi.additionalInsuredName}
                                    </span>
                                </FlexView>
                            </FlexView>
                        ))}
                    </RadioGroup>
                </>
                }
            </Grid>
            
            {policyCoiContext.cois.length > 0 && (
                <FlexView hAlignContent="center" vAlignContent="center" className={`${isMobile && 'fixed-bottom'} margin-top-large margin-bottom-large`}>

                                                        <NewFillButton onClick={handleViewSelectedCOI}
                                                        className={`full-width margin-right-basic margin-left-basic ${!selectedCOI && 'disabled-button'}`}
                                                        >View Certification</NewFillButton>
  
                </FlexView>
            )}
        </>
    )
}